import { useState } from "react";

import { PIN_TYPES } from "models";
import {
  ORDER_BY,
  REG_VIN_FILTER,
  useAppointmentOrderingOptions,
  useGetPinWarrantyTypeOptions,
  useGetQuestionStatusOptions,
  useGetWarrantyDashboardFilters,
  useLocationOrderingOptions
} from "modules/WarrantyDashboard/hooks";

export const DEFAULT_PIN_TYPES = [PIN_TYPES.Recall, PIN_TYPES.Remarks, PIN_TYPES.Warranty];

const getSelectedPinTypes = (pinTypeIds: PIN_TYPES[] | null) => {
  if (pinTypeIds?.length === DEFAULT_PIN_TYPES.length) return ["all"];
  return pinTypeIds?.map(String) ?? ["all"];
};

const getClaimOrderArrow = (claimOrderBy: ORDER_BY | null) => {
  if (!claimOrderBy) return "up grey";
  return claimOrderBy === ORDER_BY.ClaimAscending ? "up" : "down";
};

export const useGetSelectedFilterValues = () => {
  const [regVinNumberFilter, setRegVinNumberFilter] = useState(REG_VIN_FILTER.Reg);

  const { filters } = useGetWarrantyDashboardFilters();
  const questionStatusOptions = useGetQuestionStatusOptions();
  const warrantyTypeOptions = useGetPinWarrantyTypeOptions();
  const appointmentOrderingOptions = useAppointmentOrderingOptions();
  const locationOrderingOptions = useLocationOrderingOptions();

  const selectedStatus = String(questionStatusOptions.find(option => option.value === filters.status)?.value);
  const selectedAppointmentOrder = String(appointmentOrderingOptions.find(option => option.value === filters.order_by)?.value || "");
  const selectedWarrantyType = warrantyTypeOptions.find(option => option.value === filters.warranty_type_id)?.value.toString() || "all";
  const isDateRangeSelected = filters.pin_date_from && filters.pin_date_to && filters.appointment_date_from && filters.appointment_date_to;
  const isRecallOrRemarksSelected = filters.pin_type_id?.every(pinType => pinType === PIN_TYPES.Recall || pinType === PIN_TYPES.Remarks);
  const selectedAppointmentOrderText = appointmentOrderingOptions.find(option => option.value === filters.order_by)?.text;
  const selectedLocationOrder = String(locationOrderingOptions.find(element => element.value === filters.order_by_location)?.value ?? "all");

  return {
    setRegVinNumberFilter,
    isRecallOrRemarksSelected,
    selectedStatus,
    regVinNumberFilter,
    warrantyTypeOptions,
    selectedWarrantyType,
    questionStatusOptions,
    isDateRangeSelected,
    selectedAppointmentOrder,
    selectedAppointmentOrderText,
    appointmentOrderingOptions,
    selectedLocationOrder,
    locationOrderingOptions,
    selectedPinTypes: getSelectedPinTypes(filters.pin_type_id ?? null),
    claimOrderArrow: getClaimOrderArrow(filters.claim_order_by ?? null)
  };
};
